import React, { useEffect } from "react";
import { Card, Table, Layout, Space } from "antd";
import { observer } from "mobx-react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { articlePublishesStore } from "../../store/content/article/ArticlePublishesStore";
import { fmtDateTime } from "../../common/Utils";
import { ArticleInfo } from "./ArticleInfo";

const commentTypes = {
  None: "None",
  Private: "Self Visible",
  Public: "Public",
};

export const ArticlePublishHistory = observer(() => {
  let { id } = useParams<any>();

  const location = useLocation();
  const history = useHistory();

  const store = articlePublishesStore;

  const onPage = (page, pageSize) => {
    store.onPage(history, page, pageSize);
  };
  useEffect(() => {
    store.filter.articleId = id;
    store.onLocation(location);
  }, []);

  useEffect(() => {
    store.onLocation(location);
  }, [location.search]);

  const columns = [
    { title: "", key: "i", render: (t, r, i) => i + 1 },
    {
      title: "Publishing Type",
      dataIndex: "type",
    },
    {
      title: "Publishing Time",
      dataIndex: "publishDate",
      render: (_, r) =>
        r.type === "All" || r.type === "Community"
          ? fmtDateTime(r.publishDate)
          : r.publishToNewUser
          ? "New User"
          : `On day ${r.publishDay} at time ${r.publishTime}`,
    },
    {
      title: "Comment Type",
      dataIndex: "commentType",
      render: (_, r) => commentTypes[r.commentType],
    },
    {
      title: "Platform",
      dataIndex: "platform",
      render: (_, r) => (r.platform || []).join(", "),
    },
    {
      title: "User",
      dataIndex: "publishBy",
    },
    {
      title: "Publishing Status",
      dataIndex: "state",
    },
    {
      title: "Publishing Details",
      dataIndex: "communities",
      render: (_, r) => (r.type === "Community" ? r.communities.map((x) => x.name).join(", ") : ""),
    },
    {
      title: "",
      render: (_, r) => (
        <Space>{r.state === "Scheduled" && <a onClick={() => store.withdrawn(r.id)}>Withdraw</a>}</Space>
      ),
    },
  ];

  return (
    <Layout.Content className="padding24">
      {/* <Card bodyStyle={{ padding: "16px 8px" }} style={{ margin: "16px 0" }}>
        <FilterBar
          store={store}
          actions={
            <Button type="primary" onClick={() => store.editStore.show()}>
              New Article
            </Button>
          }
        >
          <Form.Item label="Keyword">
            <Input.Search value={store.filter.keyword} onChange={(e) => (store.filter.keyword = e.target.value)} />
          </Form.Item>
        </FilterBar>
      </Card> */}
      <ArticleInfo article={store.article} />

      <Card size="small" title="Article Publishing Records" bodyStyle={{ padding: 0 }}>
        <Table
          size="small"
          pagination={{ ...store.pagination, onChange: onPage }}
          loading={store.loading}
          rowKey="id"
          columns={columns}
          dataSource={store.data.items}
        />
      </Card>
    </Layout.Content>
  );
});
